import {
    Alert,
    Box,
    Popover,
} from '@mui/material';
import { useTranslation } from 'react-i18next';


function RegulationPopover({ insufficentBreakError, coherentError, gapError, regulationHour, regulationBreak, open, anchorEl, onClose, anchorOrigin }) {
    const { t } = useTranslation();

    return (
        <>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={anchorOrigin}
            >
                <Box sx={{ p: '10px', width: '1000px', gap: 5 }}>
                    {insufficentBreakError &&
                        <Alert severity='warning'>
                            {
                                t('zuWenigPause', {
                                    ns: 'dashboardPage', regulationHour: regulationHour, regulationBreak: regulationBreak,
                                    defaultValue: 'Bei mehr als {{regulationHour}} Stunden Arbeit erfordert das Arbeitszeitgesetz, dass du mindestens {{regulationBreak}} Minuten Pause machst. Die Pause kannst du in kleinere Pausen von mindestens 15 Minuten einteilen.'
                                })
                            }
                        </Alert>
                    }
                    {
                        coherentError &&
                        <Alert severity='warning' sx={{ mt: 1 }}>
                            {t('nichtMehrAls', {ns : 'dashboardPage', defaultValue: 'Nach Arbeitszeitgesetz darfst du nicht mehr als 6 Stunden am Stück ohne Pause arbeiten.'})}
                        </Alert>
                    }

                    {gapError &&
                        <Alert severity='warning' sx={{ mt: 1 }}>
                            {t('11StundenAbstand', {ns : 'dashboardPage', defaultValue: 'Zwischen zwei Arbeitstagen erfordert das Arbeitszeitgesetz eine Ruhezeit von mindestens 11 Stunden.'})}                   
                        </Alert>
                    }
                </Box>
            </Popover>
        </>
    );
};

export default RegulationPopover
